import React from 'react';

// Maps status strings to CSS badge variants
const VARIANT_MAP = {
  // Quiz & Season status mapping
  Upcoming:    'warning',
  Ongoing:     'success',
  Finished:    'neutral',
  Completed:   'neutral',
  active:      'success',
  completed:   'neutral',
  deactivated: 'danger',
  // Generic
  success: 'success',
  danger:  'danger',
  warning: 'warning',
  info:    'info',
};

const DISPLAY_MAP = {
  active: 'Ongoing',
  completed: 'Completed',
};

/**
 * Badge
 * Props:
 *   status  — string key (auto-maps to a color variant)
 *   variant — override: 'success' | 'danger' | 'warning' | 'info' | 'neutral'
 *   label   — override display text (defaults to status value)
 */
const Badge = ({ status, variant, label }) => {
  const v = variant || VARIANT_MAP[status] || 'neutral';
  return (
    <span className={`badge badge--${v}`}>
      {label ?? DISPLAY_MAP[status] ?? status}
    </span>
  );
};

export default Badge;
